/**
 * Active/Deactivated status cell for server-backed grids.
 *
 * The one rendering of the `deactivated` flag: an "Active" ok-pill or a
 * "Deactivated" neutral pill, in the grid column and the mobile card's
 * status slot alike. `deactivated` is semantically inverted from the
 * boolean cell's default (true → ok), which is why grids need this cell
 * instead of the descriptor's boolean rendering.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

import GridStatusCell from './GridStatusCell';

/**
 * @param {object} props
 * @param {boolean} props.deactivated - The row's `deactivated` flag.
 */
export default function GridActiveCell({ deactivated }) {
  const { t } = useTranslation();
  return (
    <GridStatusCell
      color={deactivated ? 'neutral' : 'ok'}
      label={deactivated ? t('general.deactivated') : t('general.active', 'Active')}
    />
  );
}
